import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("CEPFilter")
export class CEPFilter {

  cep: string;
}
